import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { WalletProvider } from './contexts/WalletContext';
import WalletButton from './components/WalletButton';
import LandingPage from './components/LandingPage';
import DashboardPage from './components/DashboardPage';
import CreateDonationPage from './components/CreateDonationPage';
import DonationForm from './components/DonationForm';
import OBSWidget from './components/OBSWidget';
import HowItWorksPage from './components/HowItWorksPage';
import './App.css';

// Компонент для условного рендеринга хедера
const AppContent: React.FC = () => {
  const location = useLocation();
  const isDonationPage = location.pathname.startsWith('/donate/');
  const isOBSPage = location.pathname.startsWith('/obs/');

  return (
    <div className="min-h-screen">
      {/* Navigation - показываем только если это не донатная или OBS страница */}
      {!isDonationPage && !isOBSPage && (
        <nav className="navbar">
          <div className="navbar-content">
            <a href="/" className="navbar-brand">
              <span className="streamlab-text">Stream<span className="lab">Lab</span></span>
            </a>
            
            <div className="navbar-nav">
              <a href="/dashboard" className="navbar-link">
                Dashboard
              </a>
              <a href="/create" className="navbar-link">
                Create Page
              </a>
              <a href="/how-it-works" className="navbar-link">
                How It Works
              </a>
              <a href="https://x.com/streamlabfun" target="_blank" rel="noopener noreferrer" className="navbar-link x-link">
                <span className="x-icon">𝕏</span>
              </a>
            </div>
            
            <div className="navbar-actions">
              <WalletButton />
            </div>
          </div>
        </nav>
      )}

      {/* Main Content */}
      <main>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/create" element={<CreateDonationPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/donate/:id" element={<DonationForm />} />
          <Route path="/obs/:id" element={<OBSWidget />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
};

function App() {
  return (
    <WalletProvider>
      <Router>
        <AppContent />
      </Router>
    </WalletProvider>
  );
}

export default App;